export * from 'mitt';
import mitt from 'mitt';
export default mitt;
export { mitt };
